export enum Vehicle {
  _10_Wheeler = '_10_WHEELER',
  _18_Wheeler = '_18_Wheeler',
  Light_truck_3500 = 'LIGHT_TRUCK_3500',
  Light_truck_7000 = 'LIGHT_TRUCK_7000',
  Other = 'OTHER_FTL',
  PanelVan = 'PANEL_VAN',
  SemiTruck = 'SEMI_TRUCK',
  Truck_1800 = 'TRUCK_18000',
  Van = 'VAN',
}
